module.exports = __webpack_public_path__ + "static/media/usersIcon.766affc7.svg";